import { useEffect, useState } from 'react'
import styles from '@/components/ui/pagination/CountComponent.module.css'

function CountComponent({ onCountChange, initialCount }) {
  const [count, setCount] = useState(initialCount)

  useEffect(() => {
    setCount(initialCount)
  }, [initialCount])

  const handleChange = (event) => {
    const newCount = parseInt(event.target.value, 10)
    setCount(newCount)
    onCountChange(newCount)
  }

  return (
    <div>
      <label className={styles.countLabel}>Results per page: </label>
      <select value={count} onChange={handleChange} className={styles.valueSelect}>
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
      </select>
    </div>
  )
}

export default CountComponent
